// extracted by mini-css-extract-plugin
export default {"sider":"SideNav_sider__0z1c9","logo":"SideNav_logo__qa8m8","menu":"SideNav_menu__rB+SS","steps":"SideNav_steps__VTJv4"};